import api from '@/api'

export default {
  async getContext({ commit, state }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)

    try {
      const response = await api.getContext()
      commit('SET_CONTEXT', response.data)
    } catch (error) {
      commit('SET_ERROR', 'Error loading connected devices context.')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async saveConnectedDevices({ commit }, { manufacturerDeviceId, deviceIds }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)

    try {
      await api.saveConnectedDevices(manufacturerDeviceId, deviceIds)
    } catch (error) {
      commit('SET_ERROR', 'Error saving connected devices.')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async upsertManufacturerDevice({ dispatch }, manufacturerDevice) {
    await api.upsertManufacturerDevice(manufacturerDevice)
    await dispatch('getContext')
  },

  async removeManufacturerDevice({ dispatch }, manufacturerDeviceId) {
    await api.removeManufacturerDevice(manufacturerDeviceId)
    await dispatch('getContext')
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/connecteddevices/actions.js